import React, { useEffect, useState } from 'react';
import '../Admin.css';
import './newsavings.scss';
// import Loader from 'components/Loader';
import api from 'appRedux/api';
import {
  openNotificationWithIcon,
  openNotificationWithIconErr,
} from 'appRedux/actions/Common';
import {
  getCurrency,
  objectValuesStringify,
  removeCommaAmount,
} from 'helpers/utils';
import { Platformbutton } from 'components/common/button/button';
import { Backcontinue } from 'components/common/backcontinue/backcontinue';
import { Success } from 'components/common/success/success';
import errorsvg from '../../../assets/errorsvg.svg';
import wallet from '../../../assets/radios/radio_wallets.svg';
// import bankcard from '../../../assets/radios/radio_bankcard.svg';
import newcard from '../../../assets/radios/radio_newcards.svg';
// import { Singleselect } from 'components/common/inputs/singleselect';
// import Inputfloat from 'components/common/inputs/inputfloat';
import { Transreview } from 'components/common/transactionreview/review';
import { Form } from 'antd';
import { RadioOption } from 'components/common/radiobutton/radiobutton';
import { Amountinputcurrency } from 'components/common/inputs/amountinput';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import { AlertError } from 'components/common/alertboxes/alertboxes';
import { Littlebalance } from 'components/bank/littlebalance/littlebalance';

const TopUp = ({ close, user, selectedPlan, getSavings }) => {
  const allWallet = useSelector(state => state.wallets.wallets, _.isEqual);

  const defaultWallet = allWallet?.find(item => item.default === true);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [transMessage, setTransMessage] = useState('');
  const [formData, setFormData] = useState({
    amount: '',
    paymentChannel: '',
  });

  const formatNumberInput = value => {
    // Remove existing commas and convert to string
    const stringValue = value.toString().replace(/,/g, '');

    // Use a regular expression to add commas for thousands separators
    const formattedValue = stringValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return formattedValue;
  };

  var setInput = e => {
    var name = e.target.name;
    var value = e.target.value;

    if (name === 'targetAmount' || name === 'amount') {
      value = formatNumberInput(value);
    }

    setFormData({ ...formData, [name]: value });
    // console.log(formData);
  };

  var handleSelect = (name, value) => {
    setFormData({ ...formData, [name]: value?.value });
    // console.log(formData);
  };

  // console.log('Top Up Savings Plan: ', selectedPlan);

  const handleFundSavingsPlan = async () => {
    const url = '/safe-lock/top-up';
    const data = {
      safeLockId: selectedPlan.id,
      paymentChannel: formData.paymentChannel,
    };
    // console.log(data);
    setLoading(true);
    try {
      const res = await api.post(url, data);
      // console.log({ ...res });
      openNotificationWithIcon(res.data?.message, 'Savings Top Up', 'success');
      setTransMessage(res.data?.message);
      if (res.data?.data?.link) {
        window.open(res.data?.data?.link, '_blank');
      }
      setStep(3);
    } catch (error) {
      if (error?.data?.errors) {
        setTransMessage(error?.data?.errors);
        openNotificationWithIconErr(
          objectValuesStringify(error?.data?.errors),
          'Savings Top Up',
          'error',
        );
        setStep(4);
      } else {
        //console.log('err', error?.data?.message);
        setTransMessage(error?.data?.message || error?.message);
        openNotificationWithIconErr(
          error?.data?.message || error?.message,
          'Savings',
          'error',
        );
        setStep(4);
      }
      //console.log({ ...error });
    }
    setLoading(false);
  };

  const handlePageFocus = () => {
    if (step === 4) {
      close(); // Close the modal
      getSavings(); // Refetch the function
    }
  };

  useEffect(() => {
    // Add event listener for page focus
    window.addEventListener('focus', handlePageFocus);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('focus', handlePageFocus);
    };
  }, [step]);

  var __renderSteps = () => {
    switch (step) {
      case 0:
        return (
          <StepOne
            step={step}
            setStep={setStep}
            formData={formData}
            setFormData={setFormData}
            setInput={setInput}
            handleSelect={handleSelect}
            loading={loading}
            setLoading={setLoading}
            close={close}
          />
        );
      case 1:
        return (
          <StepTwo
            step={step}
            close={close}
            setStep={setStep}
            formData={formData}
            setFormData={setFormData}
            setInput={setInput}
            handleSelect={handleSelect}
            loading={loading}
            setLoading={setLoading}
            selectedPlan={selectedPlan}
            defaultWallet={defaultWallet}
          />
        );
      case 2:
        return (
          <Finalize
            step={step}
            setStep={setStep}
            formData={formData}
            setFormData={setFormData}
            setInput={setInput}
            handleSelect={handleSelect}
            loading={loading}
            selectedPlan={selectedPlan}
            setLoading={setLoading}
            handleFundSavingsPlan={handleFundSavingsPlan}
            defaultWallet={defaultWallet}
          />
        );
      case 3:
        return (
          <Success
            title="Successfully Initiated"
            subtitle={transMessage}
            onClick={() => close()}
            button="Okay, thank you"
          />
        );
      case 4:
        return (
          <Success
            image={errorsvg}
            title={`Failed`}
            subtitle={transMessage}
            onClick={() => setStep(1)}
            button="Try Again"
            type="error"
          />
        );
      default:
        return <></>;
    }
  };

  return <div className="create-savings-box">{__renderSteps()}</div>;
};

const StepOne = props => {
  // console.log('StepOne: ', props);
  return (
    <Form className="create-savings-form w-100">
      <div className="title">
        <p>Step 1 of 3</p>
        <p>Savings Target</p>
      </div>
      <div className="w-100">
        <div className="mt-4">
          <Amountinputcurrency
            type="text"
            currency={getCurrency(props.formData.currency)}
            name="amount"
            label="Amount"
            value={props.formData.amount}
            disabled={false}
            placeholder="Enter amount to save Frequently"
            onChange={props.setInput}
            pattern="[0-9,.]*"
            autoComplete="false"
          />
        </div>
        <Backcontinue goBack={() => props.close()}>
          <Platformbutton
            name="Proceed"
            type="normal"
            click={() => props.setStep(1)}
            disabled={
              props.formData.currency.value === '' ||
              !props.formData.name ||
              props.formData.frequency.value === '' ||
              !props.formData.targetAmount ||
              !props.formData.amount
                ? true
                : false
            }
          />
        </Backcontinue>
      </div>
    </Form>
  );
};

const StepTwo = props => {
  return (
    <>
      <Form className="create-savings-form ">
        <div className="title">
          <p>Step 1 of 2</p>
          <p>Select Savings Method</p>
        </div>
        <div className="radios">
          <RadioOption
            image={wallet}
            changed={value =>
              props.setFormData({ ...props.formData, paymentChannel: value })
            }
            id="0"
            isSelected={props.formData.paymentChannel === 'wallet'}
            label="Save with your Vesti Wallet"
            sublabel=""
            value="wallet"
          />
          {props.formData.paymentChannel === 'wallet' && (
            <div className="d-flex justify-content-start w-100">
              <Littlebalance
                type={(props.defaultWallet?.currency).toLowerCase()}
                title={`${props.defaultWallet?.currency} Balance`}
                currency={getCurrency(props.defaultWallet?.currency)}
                amount={props.defaultWallet?.balance / 100}
              />
            </div>
          )}
          {props.formData.paymentChannel === 'wallet' &&
            props.defaultWallet?.balance / 100 <
              props.selectedPlan?.amount / 100 && (
              <div className="d-flex justify-content-start w-100">
                <AlertError
                  body={`You do not have upto ${getCurrency(
                    props.defaultWallet?.currency,
                  )} ${(
                    props.selectedPlan.amount / 100
                  ).toLocaleString()} in your Vesti wallet, please deposit into your account.`}
                />
              </div>
            )}

          <RadioOption
            image={newcard}
            changed={value =>
              props.setFormData({ ...props.formData, paymentChannel: value })
            }
            id="1"
            isSelected={props.formData.paymentChannel === 'card'}
            label="Save with your debit card"
            sublabel=""
            value="card"
          />
        </div>

        <div className="newsavings-backcontinue">
          <Backcontinue goBack={() => props.close()}>
            <Platformbutton
              name="Proceed"
              type="normal"
              click={() => props.setStep(2)}
              disabled={
                !props.formData.paymentChannel ||
                (props.formData.paymentChannel === 'wallet' &&
                  props.defaultWallet?.balance / 100 <
                    props.selectedPlan?.amount / 100)
                // ? true
                // : false
              }
            />
          </Backcontinue>
        </div>
      </Form>
    </>
  );
};

const Finalize = props => {
  // console.log('Finalize: ',props)
  return (
    <div className="create-savings-form ">
      <div className="title">
        <p>Step 2 of 2</p>
      </div>
      <div className="topup-transreview">
        <Transreview
          data={[
            {
              title: 'Transaction Type',
              value: `Instant Top Up`,
            },
            { title: 'Savings plan', value: props.selectedPlan.name },
            {
              title: 'Amount',
              value: `${removeCommaAmount(
                props.selectedPlan.amount / 100,
              ).toLocaleString('en-US')}`,
            },
            {
              title: 'Payment Method',
              value: props.formData.paymentChannel,
            },
          ]}
        />
      </div>
      <div className="mb-2"></div>

      <div className="mb-2"></div>

      <Backcontinue goBack={() => props.setStep(1)}>
        <Platformbutton
          name="Finalize transaction"
          type="normal"
          click={() => props.handleFundSavingsPlan()}
          disabled={props.loading ? true : false}
        />
      </Backcontinue>
    </div>
  );
};

export default TopUp;
